export default {
    "profile": "प्रोफ़ाइल",
    "logout": "लॉग आउट",
    "dashboard": "डैशबोर्ड",
    "password": "पासवर्ड",
    "language": "भाषा",
    "paymentbr": "भुगतान",
    "subscriptionPaymentMethod": "सदस्यता एवं भुगतान विधि",
    "nothingchanged": "कुछ भी नहीं बदला",
    "somethingWentWrong": "कुछ गलत हो गया ! कृपया बाद में पुनः प्रयास करें",
    "pleaseTryAgainAfterSometime": "कृपया कुछ समय बाद पुनः प्रयास करें",
    "noChanges": "परिवर्तित नहीं",
    "invalidEmailFormat": "ईमेल प्रारूप अमान्य है",
    "chooseYourPreferredLanguage": "कृपया अपनी पसंदीदा भाषा चुनें.",
    "selectLanguage": "भाषा चुने",
    "update": "अद्यतन",
    "languagePreferences": "भाषा प्राथमिकताएँ",
    "packageOf": "का पैकेज",
    "satelliteReport": "सैटेलाइट रिपोर्ट",
    "pastureReport": "चारागाह रिपोर्ट",
    "upTo": "तक",
    "animals": "जानवरों",
    "back": "पीछे",
    "perMonth": "प्रति महीने",
    "perYear": "प्रति वर्ष",
    "continue": "जारी रखना",
    "changePlan": "योजना बदलें",
    "addOn": "ऐड ऑन",
    "totalPrice": "कुल कीमत",
    "availableAddOns": "उपलब्ध ऐड-ऑन",
    "next": "अगला",
    "congratulations": "बधाई हो",
    "done": "हो गया",
    "deforestationComplianceAssessment": "वनों की कटाई अनुपालन आकलन",
    "warning": "चेतावनी",
    "yourDataMightLost": "आपका डेटा खो सकता है.",
    "clickOnSaveBtnMsg": "अपने डेटा को सुरक्षित रखने के लिए सेव बटन पर क्लिक करें",
    "discardChanges": "परिवर्तनों को निरस्त करें",
    "action": "कार्रवाई",
    "sendRequest": "अनुरोध भेजा",
    "success": "सफलता",
    "yourRequestSuccessfullySubmitted": "आपका अनुरोध सफलतापूर्वक सबमिट कर दिया गया.",
    "informShortly": "आपका अनुरोध सफलतापूर्वक सबमिट कर दिया गया है. आपकी विश्लेषण रिपोर्ट शीघ्र ही आपको भेज दी जाएगी।",
    "search": "खोज",
    "pending": "लंबित",
    "approved": "अनुमत",
    "rejected": "अस्वीकृत",
    "primaryGeofence": "प्राथमिक भूबाड़",
    "Zero/Negligible Deforestation Probability": "शून्य/नगण्य वनों की कटाई की संभावना",
    "Low Deforestation Probability": "कम वनों की कटाई की संभावना",
    "High Deforestation Probability": "उच्च वनों की कटाई की संभावना",
    "login": {
        "welcome": "स्वागत! लॉग इन करें",
        "welInfo": "अपनी साख दर्ज करें.",
        "login": "लॉग इन करें",
        "emailMobile": "ईमेल/मोबाइल",
        "forgotPassword": "पासवर्ड भूल गए",
        "register": "पंजीकरण करवाना",
        "unableToLogin": "लॉगिन करने में असमर्थ",
        "emailMobileCannotEmpty": "ईमेल/मोबाइल खाली नहीं रह सकता.",
        "invalidEmailMobileFormat": "अमान्य ईमेल/मोबाइल प्रारूप.",
        "passwordCannotEmpty": "पासवर्ड खाली नहीं हो सकता.",
        "passwordLengthCanlessthan8": "पासवर्ड की लंबाई 8 अक्षर से कम नहीं हो सकती.",
        "email": "ईमेल",
        "phone": "फ़ोन",
        "or": "या",
        "alreadyHaveAccount": "क्या आपके पास पहले से एक खाता मौजूद है",
        "loginNow": "अभी लॉगिन करें",
        "registerOption": "साइन अप करने के लिए एक विकल्प चुनें",
        "signUpWith": "इसके साथ साइन अप करें"
    },
    "user": {
        "profileUpdated": "प्रोफ़ाइल सफलतापूर्वक अपडेट हो गई है",
        "profileNotUpdated": "प्रोफ़ाइल अपडेट नहीं हुई है",
        "otpSentOnEmail": "ओटीपी सफलतापूर्वक भेजा गया!",
        "otpSentSuccessFully": "आपका ओटीपी कोड भेजा गया था",
        "unableToVerifyEmail": "ईमेल सत्यापित करने में असमर्थ",
        "emailCanNotBeEmpty": "ईमेल फ़ील्ड खाली नहीं हो सकते",
        "firstName": "पहला नाम",
        "lastName": "उपनाम",
        "email": "ईमेल",
        "mobile": "गतिमान",
        "currentPassword": "वर्तमान पासवर्ड",
        "newPassword": "नया पासवर्ड",
        "repeatNewPassword": "नया पासवर्ड दोहराएँ",
        "firstNameRequired": "पहला नाम आवश्यक है।",
        "lastNameRequired": "अंतिम नाम आवश्यक है",
        "emailRequired": "ईमेल की जरूरत है",
        "onlyAlphabet": "केवल अक्षर हो सकते हैं",
        "notMoreThan15Char": "15 से अधिक अक्षर नहीं हो सकते",
        "phoneCannotLessThan8Char": "फ़ोन 8 अक्षर से कम नहीं हो सकता",
        "countryCodeRequire": "देश कोड आवश्यक है",
        "changePassword": "पासवर्ड बदलें",
        "goodIdeaToUsePassword": "एक मजबूत पासवर्ड का उपयोग करना एक अच्छा विचार है जिसे आप कहीं और उपयोग नहीं कर रहे हैं।",
        "enterCurrentPassword": "वर्तमान पासवर्ड दर्ज करें",
        "enterNewPassword": "नया पासवर्ड दर्ज करें",
        "reEnterPassword": "पासवर्ड फिर से दर्ज करें",
        "pleaseTypeOldPassword": "कृपया पुराना पासवर्ड टाइप करें.",
        "pleaseTypeNewPassword": "कृपया नया पासवर्ड टाइप करें.",
        "pleaseTypeConfirmPassword": "कृपया पुष्टि पासवर्ड टाइप करें.",
        "passwordChangedSuccesFully": "पासवर्ड सफलतापूर्वक बदला गया",
        "passwordDoesNotMatch": "पासवर्ड मेल नहीं खाते.",
        "passwordRequired": "पासवर्ड की आवश्यकता है",
        "emailOrPhoneIsRequired": "ईमेल या फ़ोन नंबर आवश्यक है"
    },
    "subscription": {
        "subscription": "अंशदान",
        "membershipPlan": "सदस्यता योजनाएँ",
        "currentMembershipPlan": "वर्तमान सदस्यता योजना",
        "validUpTo": "तक वैध है",
        "viewAllAddOns": "सभी ऐड-ऑन देखें",
        "renewValidity": "वैधता नवीनीकृत करें",
        "buyNow": "अभी खरीदें",
        "upgradeMembershipPlan": "सदस्यता योजना अपग्रेड करें",
        "chooseYourMembershipPlan": "आपकी चुनी हुई सदस्यता योजना",
        "chooseOptionalAddOns": "आप वैकल्पिक ऐड-ऑन चुन सकते हैं",
        "yourSelectedAddons": "आपके चयनित ऐड-ऑन",
        "addAnotherAddOn": "एक और ऐड-ऑन जोड़ें",
        "paymentMethod": "भुगतान विधि",
        "addingAPaymentMethod": "एक भुगतान विधि जोड़ा जा रहा है",
        "paymentSuccessful": "आपका भुगतान सफल रहा!",
        "weHaveEmailed": "हमने आपकी रसीद की एक प्रति example@email.com पर ईमेल कर दी है",
        "paymentAuthorizedSuccessfully": "भुगतान सफलतापूर्वक अधिकृत.",
        "paymentSuccessfulPrompt": "भुगतान सफल। योजना उन्नत की गई.",
        "paymentCancelled": "भुगतान रद्द कर दिया गया. कृपया पुन: प्रयास करें।"
    },
    "registerFarm": "फार्म पंजीकृत करें",
    "requestDeforestationReport": "वनों की कटाई की रिपोर्ट का अनुरोध करें",
    "paymentMenu": "भुगतान",
    "complianceCertificate": "अनुपालना प्रमाण पत्र",
    "helpDisk": "सहायता डिस्क",
    "faqs": "अक्सर पूछे जाने वाले प्रश्न",
    "enquiries": "पूछताछ",
    "contactUs": "संपर्क करें",
    "payment": {
        "basicPlan": "मूल योजना",
        "advancePlan": "अग्रिम योजना",
        "usdPerMonthPlus": "USD प्रति माह प्लस",
        "perReport": "प्रति रिपोर्ट",
        "deforestationAnalyticsCertificateDownload": "वनों की कटाई विश्लेषण प्रमाणपत्र डाउनलोड"
    },
    "farm": {
        "farmOwnershipType": "फार्म स्वामित्व प्रकार",
        "licenceNum": "अधिकार पत्र संख्या",
        "viewFarm": "फार्म देखें",
        "stateProvince": "प्रांत/राज्य",
        "postalNumberShouldSimilarToFarm": "खेत का डाक नंबर मकान नंबर के समान।",
        "videoTutorial": "वीडियो ट्यूटोरियल",
        "clickOnMapMSG": "जियोफेंसिंग शुरू करने के लिए मानचित्र पर क्लिक करें",
        "prev": "पिछला",
        "next": "अगला",
        "dragVertexMsg": "आप शीर्ष को खींच भी सकते हैं, या दाईं ओर स्थित डिलीट बटन का उपयोग करके उन्हें हटा भी सकते हैं। क्लियर बटन का उपयोग करके जियोफेंस को भी साफ किया जा सकता है",
        "farmAddedSuccessfully": "फ़ार्म सफलतापूर्वक जोड़ा गया",
        "perimeter": "परिमाप",
        "area": "क्षेत्र",
        "clearGeofence": "साफ़ जियोफ़ेंस",
        "deleteSelectedVertex": "चयनित शीर्ष हटाएँ",
        "pleaseStartDrawing": "कृपया मानचित्र पर भू-बाड़ बनाना प्रारंभ करें।",
        "chooseTheDate": "तारीख चुनें",
        "updateGeofenceForThisFarm": "इस फार्म के लिए जियोफेंस को अद्यतन करें",
        "farmUpdateSuccessfully": "फ़ार्म सफलतापूर्वक अद्यतन किया गया",
        "farmZone": "फार्म जोन",
        "addNewZones": "नए जोन जोड़ें",
        "zoneName": "जोन का नाम",
        "addZoneToCreate": "कृपया इस फार्म के लिए जोन बनाने के लिए जोन जोड़ें पर क्लिक करें।",
        "noZoneCreated": "अभी तक कोई जोन नहीं बनाया गया है.",
        "searchAndAddPin": "खोजें और एक पिन जोड़ें",
        "zoneNameWillBeHere": "जोन का नाम यहां होगा",
        "editZone": "जोन संपादित करें",
        "nameOfTheField": "फ़ील्ड का नाम",
        "zoneDetails": "जोन विवरण",
        "addZone": "ज़ोन जोड़ें",
        "nameOfTheZone": "जोन का नाम",
        "geofenceIsRequiredToAdd": "जोन जोड़ने के लिए जियोफेंस की आवश्यकता है। अपने फ़ार्म में जियोफ़ेंस विवरण जोड़ने के लिए `फ़ार्म संपादित करें` पर क्लिक करें।",
        "thisFieldApplyHelpText": "यह क्षेत्र केवल आप पर लागू होता है यदि आप किसी सहकारी समिति से संबंधित हैं (एक सहकारी संस्था व्यक्तियों का एक स्वायत्त संघ है जो संयुक्त स्वामित्व वाले और लोकतांत्रिक रूप से नियंत्रित उद्यम के माध्यम से अपनी सामान्य आर्थिक, सामाजिक और सांस्कृतिक आवश्यकताओं और आकांक्षाओं को पूरा करने के लिए स्वेच्छा से एकजुट होते हैं)। यदि आप किसी सहकारी समिति से संबंधित हैं, तो कृपया उस सहकारी समिति का विशिष्ट पहचानकर्ता बताएं, यह एक पंजीकरण या लाइसेंस नंबर हो सकता है जो विशिष्ट रूप से उस सहकारी समिति की पहचान करता है जिसके साथ आप जुड़े हैं।",
        "farmRegistrationID": "फार्म पंजीकरण आईडी",
        "farmerName": "किसान का नाम",
        "farmerRegistrationID": "किसान पंजीकरण आईडी",
        "dateOfRequest": "विनती की तारीख",
        "status": "स्थिति",
        "address": "पता",
        "save": "बचाना",
        "farmAddress": "फार्म स्थान का पता",
        "corporateName": "कंपनी का नाम",
        "corporateMailingAddress": "कॉर्पोरेट डाक पता",
        "farmID": "फार्म आईडी",
        "onTheFarm": "खेत पर",
        "userRoles": "उपयोगकर्ता भूमिका",
        "adduser": "उपयोगकर्ता जोड़ें",
        "addAuser": "एक उपयोगकर्ता जोड़ें",
        "uploadUsers": "उपयोगकर्ता अपलोड करें",
        "addNewUser": "नई उपयोगकर्ता को जोड़ना",
        "selectDept": "विभाग का चयन करें",
        "selectRole": "भूमिका चुनें",
        "editUser": "यूजर को संपादित करो",
        "totalFarms": "कुल फार्म",
        "NoAnimalsRegisteredForthisFarm": "इस फार्म के लिए कोई भी जानवर पंजीकृत नहीं है",
        "farmsPerPage": "प्रति पृष्ठ फार्म",
        "regularFarms": "नियमित फार्म",
        "farmRegisteredProducts": "फार्म पंजीकृत उत्पाद",
        "searchByFarmNameAndId": "फार्म के नाम और आईडी के आधार पर खोजें",
        "loadingProductsPleaseWait": "उत्पाद लोड हो रहे हैं... कृपया प्रतीक्षा करें",
        "farmName": "फार्म का नाम",
        "farmLocation": "खेत का स्थान",
        "productName": "प्रोडक्ट का नाम",
        "stockStatus": "स्टॉक की अवस्था",
        "inStock": "स्टॉक में",
        "searchByProductName": "उत्पाद के नाम से खोजें",
        "productCategory": "उत्पाद श्रेणी",
        "products": "उत्पादों",
        "yourLocationIsDisabled": "आपका स्थान अक्षम है. कृपया बाएं मेनू से अपना स्थान खोजें।",
        "close": "बंद करना",
        "farms": "फार्म",
        "zones": "क्षेत्र",
        "registerAfarm": "एक फार्म पंजीकृत करें",
        "govtRegistry": "सरकार. रजिस्ट्री",
        "cooperativeID": "सहकारी/संघ आईडी",
        "cooperativeName": "सहकारी/संघ का नाम",
        "farmType": "फार्म का प्रकार",
        "contractMating": "कॉन्ट्रैक्ट मेटिंग",
        "customization": "अनुकूलन",
        "recordsPerpage": "प्रति पृष्ठ अभिलेखॉ",
        "restoreDefault": "डिफ़ॉल्ट बहाल",
        "apply": "आवेदन करना",
        "CommunityName": "समुदाय का नाम",
        "searchState": "फार्म आईडी, सरकारी रजिस्ट्री, सहकारी आईडी, फार्म प्रकार, अनुबंध संभोग द्वारा खोजें",
        "farmOwner": "खेत का मालिक",
        "govRegistrationNo": "सरकारी पंजीकरण संख्या",
        "farmInformation": "खेत की जानकारी",
        "ownershipType": "स्वामित्व प्रकार",
        "farmLicenseInformation": "फार्म लाइसेंस की जानकारी",
        "licenseNumber": "लाइसेंस संख्या",
        "licenseExpiryDate": "लाइसेंस समाप्ति तिथि",
        "regulatorName": "नियामक का नाम",
        "regulatorRepresentativeName": "नियामक प्रतिनिधि का नाम",
        "farmLocationSize": "फार्म का स्थान एवं आकार",
        "productionSystem": "कृषि प्रणाली",
        "country": "देश",
        "state": "राज्य",
        "city": "गांव/कस्बा/शहर",
        "farmNumber": "फार्म नंबर",
        "postal": "डाक का / ज़िप कोड",
        "houseNumber": "घर का नंबर",
        "farmRegistration": "फार्म पंजीकरण",
        "cancel": "रद्द करना",
        "register": "पंजीकरण करवाना",
        "ok": "ठीक है",
        "totalFarmSize": "कुल फार्म का आकार",
        "geographicLocation": "भौगोलिक स्थान",
        "farmGeographicLocation": "फार्म की भौगोलिक स्थिति",
        "perimeterPointLongitude": "परिधि बिंदु देशांतर",
        "perimeterPointLatitude": "परिधि बिंदु अक्षांश",
        "perimeterPointLabel": "परिधि बिंदु लेबल",
        "perimeterLength": "परिधि लंबाई",
        "farmLatitude": "खेत अक्षांश",
        "farmLongitude": "खेत देशांतर",
        "latitude": "अक्षांश",
        "longitude": "देशान्तर",
        "areaUnit": "क्षेत्र इकाई",
        "walkAndMeasure": "चलें और मापें",
        "useGeofenceTool": "जियोफेंस टूल का उपयोग करें",
        "editFarm": "फार्म संपादित करें",
        "update": "अद्यतन",
        "editAfarm": "एक फार्म संपादित करें",
        "nextFarm": "अगला फार्म",
        "nameoftheFarm": "फार्म का नाम",
        "registerAProduct": " एक उत्पाद पंजीकृत करें",
        "farmProducts": "कृषि उत्पाद",
        "calf": "बछड़ा",
        "steer": "रास्ते पर लाना",
        "heifer": "कलोर",
        "sire": "सर ई",
        "dam": "बाँध",
        "registerAnAnimal": "एक पशु पंजीकृत करें",
        "farmAnimals": "खेत के जानवर",
        "farm_type": "खेत-प्रकार",
        "farm_Owner": "खेत-मालिक",
        "dateOfRegistration": "पंजीकरण की तिथि",
        "dataIsNotAvailableForThisFarm": "इस फ़ार्म के लिए डेटा उपलब्ध नहीं है",
        "registerNewProduct": "एक नया उत्पाद पंजीकृत करें",
        "information": "जानकारी",
        "licenseInfo": "लाइसेंस की जानकारी",
        "locationInfo": "स्थान की जानकारी",
        "geoLocation": "भू-स्थान",
        "perimeterLengthState": "खेतों की परिधि की लंबाई (बाड़ की लंबाई)",
        "totalFarmSizeState": "एक खेत का आकार",
        "productionSystemState": "फार्म में प्रयुक्त उत्पादन प्रणाली",
        "contractMatingState": "अनुबंध संभोग कार्यक्रम का कोड जिसमें फार्म भाग लेता है।",
        "ownershipTypeState": "स्वामित्व के प्रकार",
        "regulatorRepresentativeNameState": "नियामक का प्रतिनिधित्व करने वाले व्यक्ति का नाम जिसने लाइसेंस जारी किया",
        "regulatorNameState": "नियामक का नाम जिसने लाइसेंस जारी किया",
        "licenseExpiryDateState": "दिनांक जब वर्तमान लाइसेंस समाप्त हो गया है",
        "licenseNumberState": "नियामक द्वारा जारी किया गया लाइसेंस नंबर",
        "plotNumberState": "खेत का मकान नंबर.",
        "plotNumber": "फार्म नंबर",
        "streetStatement": "खेत का सड़क का नाम.",
        "cityStatement": "वह शहर जहां फार्म स्थित है.",
        "stateStatement": "देश का वह क्षेत्र जहां फार्म स्थित है।",
        "countryState": "वह देश जहां फार्म स्थित है.",
        "farmStateInfo": "फार्म स्थान का पता",
        "perimeterPointLongitudeState": "खेत पर एक बिंदु का देशांतर.",
        "perimeterPointLatitudeState": "खेत पर एक बिंदु का अक्षांश.",
        "perimeterPointLabelState": "बिंदु का लेबल.",
        "farmLongitudeState": "खेत का देशांतर.",
        "farmLatitudeState": "खेत का अक्षांश.",
        "deleteFarm": "फ़ार्म हटाएँ",
        "corporateRegistrationNum": "कॉर्पोरेट पंजीकरण संख्या",
        "farmLocationIsRequired": "फार्म स्थान आवश्यक है."
    },
    "deforestation": {
        "addZoneToThisFarm": "इस फ़ार्म में जोन जोड़ें",
        "eudrForestAssessment": "ईयूडीआर वन आकलन",
        "requestEudrForestAssessment": "EUDR वन मूल्यांकन का अनुरोध करें",
        "pleaseChooseOption": "कृपया विकल्प चुनें",
        "requestForestReport": "वन रिपोर्ट का अनुरोध करें",
        "noDeforestationReportMsg": "वनों की कटाई की कोई रिपोर्ट नहीं मांगी गई है। कृपया कुछ वनों की कटाई की रिपोर्टों को यहां सूचीबद्ध करने का अनुरोध करें।",
        "allCountries": "सभी देश",
        "allRegions": "सभी क्षेत्र",
        "allFarms": "सभी फार्म",
        "allStatus": "सभी स्थिति",
        "viewCertificate": "प्रमाणपत्र देखें",
        "requestComplianceCertificate": "अनुपालन प्रमाणपत्र का अनुरोध करें",
        "assessmentNo": "मूल्यांकन संख्या",
        "blockchainCertificationInfo": "ब्लॉकचेन प्रमाणपत्र सत्यापन हैश प्रमाणपत्र की स्वीकृति पर उपलब्ध होगा",
        "blockchainCertificationValidation": "ब्लॉकचेन प्रमाणपत्र सत्यापन",
        "openBlockchainPage": "ब्लॉकचेन पेज खोलें",
        "clickOnAboveLink": "ब्लॉकचेन पर प्रमाणपत्र सत्यापित करने के लिए उपरोक्त लिंक पर क्लिक करें",
        "shareCertificate": "प्रमाणपत्र साझा करें",
        "high": "उच्च",
        "low": "कम",
        "zeroOrNegigible": "शून्य या नगण्य",
        "deforestationProbability": "वनों की कटाई की संभावना",
        "colorCode": "रंग कोड",
        "geofenceAarea": "जियोफेंस क्षेत्र",
        "percentageOfGeofenceArea": "जियोफेंस क्षेत्र का प्रतिशत",
        "overallDeforestationProbability": "कुल मिलाकर वनों की कटाई की संभावना",
        "deforestationComplianceReport": "वनों की कटाई अनुपालन रिपोर्ट",
        "noDeforestationComplianceReport": "कोई वनों की कटाई अनुपालन ई-रिपोर्ट नहीं मिली",
        "loadingDeforestationComplianceReport": "वनों की कटाई अनुपालन ई-रिपोर्ट लोड हो रही है",
        "farmRegistrationId": "फार्म पंजीकरण आईडी",
        "farmerName": "किसान का नाम",
        "farmerRegistrationId": "किसान पंजीकरण आईडी",
        "uniqueFarmerId": "अद्वितीय किसान आईडी",
        "uniqueFarmId": "अद्वितीय फार्म आईडी",
        "farmLocation": "खेत का स्थान",
        "area": "क्षेत्र",
        "farmAddress": "फार्म का पता",
        "dateOfRequest": "विनती की तारीख",
        "status": "स्थिति",
        "settings": "समायोजन",
        "assignmentIssued": "असाइनमेंट जारी",
        "certificateIssued": "प्रमाणपत्र जारी किया गया",
        "complianceCertification": "अनुपालन प्रमाणन",
        "noComplianceCertification": "कोई अनुपालन प्रमाणन नहीं मिला",
        "loadingComplianceCertification": "अनुपालन प्रमाणन लोड हो रहा है",
        "assessmentReport": "आकलन रिपोर्ट",
        "downloadPDF": "डाउनलोड पीडीऍफ़",
        "print": "छाप",
        "back": "पीछे",
        "farmDetails": "फार्म विवरण",
        "dimitraFarmId": "दिमित्रा फार्म आईडी",
        "dimitraFermerId": "दिमित्रा किसान आईडी",
        "totalGeofenceAreaHA": "कुल भू-बाड़ क्षेत्र (एचए)",
        "forestLossHA": "वन हानि (एचए)",
        "forestGainHA": "वन लाभ (एचए)",
        "forestUnchangedHA": "वन अपरिवर्तित (एचए)",
        "forestUnchanged": "वन अपरिवर्तित",
        "forestLoss": "वन हानि",
        "forestGain": "वन लाभ",
        "totalGeofenceArea": "कुल भूबाड़ क्षेत्र",
        "forestAssessmentHelp": "यदि इस रिपोर्ट के बारे में आपके कोई प्रश्न हैं या इसे समझने में सहायता की आवश्यकता है, तो हेल्प डेस्क के माध्यम से हमसे संपर्क करें।",
        "allReport": "सभी रिपोर्ट",
        "deforestationRepot": "वनों की कटाई की रिपोर्ट",
        "requestDeforestationReportNow": "अभी वनों की कटाई की रिपोर्ट का अनुरोध करें",
        "noRecordFound": "कोई रिकॉर्ड नहीं मिला",
        "noDeforestationReportRequested": "वनों की कटाई की कोई रिपोर्ट नहीं मांगी गई है। कृपया कुछ वनों की कटाई की रिपोर्टों को यहां सूचीबद्ध करने का अनुरोध करें।",
        "deforestationImage": "वनों की कटाई की छवि",
        "reqDeforestationReport": "वनों की कटाई की रिपोर्ट का अनुरोध करें",
        "confirm": "पुष्टि करना",
        "newForestArea": "नवीन वन क्षेत्र",
        "deforestedArea": "वनों की कटाई वाला क्षेत्र",
        "existingForestArea": "मौजूदा वन क्षेत्र",
        "deforestation": "वनों की कटाई",
        "farmName": "फार्म का नाम",
        "location": "जगह",
        "dateOfInterest": "रुचि की तिथि",
        "geofenceArea": "जियोफेंस एरिया (एचए)",
        "deforestationArea": "वनों की कटाई क्षेत्र (एचए)",
        "treeGainArea": "वृक्ष लाभ क्षेत्र (HA)",
        "currentForestArea": "वर्तमान वन क्षेत्र (HA)",
        "view": "देखना",
        "locationInfoRequired": "स्थान की जानकारी आवश्यक है",
        "geofenceNameRequired": "जियोफ़ेंस नाम आवश्यक है",
        "futureDateSelected": "भविष्य की तारीख चयनित",
        "reportGeneratedSuccessfully": "रिपोर्ट सफलतापूर्वक तैयार की गई",
        "reportCannotAdded": "रिपोर्ट जोड़ी नहीं जा सकती.",
        "primaryFarmNotFound": "प्राथमिक फ़ार्म नहीं मिला.",
        "pleaseRegisterFarmFirst": "कृपया पहले खेत का पंजीकरण करें"
    },
    "certificate": {
        "allCertificate": "सभी प्रमाणपत्र",
        "certificate": "प्रमाणपत्र"
    }
}